import type { IntroSplashSpec } from "@slot/game-shell";

/**
 * The branded intro splash's per-game values: read once by the shell's intro presenter at boot (the volatility pips,
 * the headline badge) and by `startGame` for the cards. Every game has its own cards (the Cocos scene authored them on
 * the `Card1..3` nodes: VS BATTLES, FREE SPINS, MAX WIN, with the `intro/introIcons` frames `vs`, `fs` and `max_win`).
 *
 * Keep `volatilityRating` in sync with the info page's volatility copy (`info.volatility.body` in
 * `game.<locale>.json`). The card strings live in `assets-src/game-shared-visuals/localization/game.<locale>.json`
 * under `info.intro.cardN.*`; the fallbacks below mirror the English copy.
 */
export const INTRO_SPLASH_SPEC: IntroSplashSpec = {
  // 4 / 5 — "Medium-High", as `info.volatility.body` says.
  volatilityRating: 4,

  headlineBadgeAssetPath: null,

  cards: [
    {
      icon: { sheet: "intro/introIcons", frame: "vs" },
      titleKey: "info.intro.card1.title",
      titleFallback: "VS BATTLES",
      bodyKey: "info.intro.card1.body",
      bodyFallback: "A VS symbol expands to fill its reel. Two multipliers battle — the winner applies to your win.",
    },
    {
      icon: { sheet: "intro/introIcons", frame: "fs" },
      titleKey: "info.intro.card2.title",
      titleFallback: "FREE SPINS",
      bodyKey: "info.intro.card2.body",
      bodyFallback: "Land 3 or more scatters to trigger free spins.",
    },
    {
      icon: { sheet: "intro/introIcons", frame: "max_win" },
      titleKey: "info.intro.card3.title",
      titleFallback: "MAX WIN",
      bodyKey: "info.intro.card3.body",
      bodyFallback: "Win up to 25,000× the total bet on a single round.",
    },
  ],
};
